import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import {
  ADMIN_GENERAL_SETTINGS_ROUTE_NAME,
} from '@modules/general-settings/constants';
import { useI18n } from '@modules/i18n/composables';

import {
  ADMIN_EXPORTS_MENU_ITEM,
  ADMIN_FINANCE_MENU_ITEM,
  ADMIN_MIRRORS_MENU_ITEM,
  ADMIN_PARTNERS_MENU_ITEM,
  ADMIN_PARTNERSHIP_MENU_ITEM,
  ADMIN_PERSONNEL_MENU_ITEM,
  ADMIN_PLAYERS_MENU_ITEM,
  ADMIN_SETTINGS_MENU_ITEM,
  AFFILIATE_EXPORTS_MENU_ITEM,
  AFFILIATE_PARTNERSHIP_MENU_ITEM,
  AFFILIATE_REPORTS_MENU_ITEM,
  AFFILIATE_TRACKING_LINKS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from './constants';
import { getTranslationKeys } from './translations';

export class SidebarModule extends AppModule {
  addRoutes(): void {}

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    // admin
    menu.addAdminMenuItem({
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'PARTNERS_GROUP_HEADER'),
      icon: 'pi pi-users',
      id: ADMIN_PARTNERS_MENU_ITEM,
      order: 20,
    });
    menu.addAdminMenuItem({
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'FINANCE_GROUP_HEADER'),
      icon: 'pi pi-money-bill',
      id: ADMIN_FINANCE_MENU_ITEM,
      order: 25,
    });
    menu.addAdminMenuItem({
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'PLAYERS_GROUP_HEADER'),
      icon: 'pi pi-star',
      id: ADMIN_PLAYERS_MENU_ITEM,
      order: 30,
    });
    menu.addAdminMenuItem({
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'ADMIN_PARTNERSHIP_GROUP_HEADER'),
      icon: 'pi pi-briefcase',
      id: ADMIN_PARTNERSHIP_MENU_ITEM,
      order: 40,
    });
    menu.addAdminMenuItem({
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'PERSONNEL_GROUP_HEADER'),
      icon: 'pi pi-user',
      id: ADMIN_PERSONNEL_MENU_ITEM,
      order: 50,
    });
    menu.addAdminMenuItem({
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'SYSTEM_SETTINGS_GROUP_HEADER'),
      icon: 'pi pi-cog',
      key: 'system_settings.group_header',
      id: ADMIN_SETTINGS_MENU_ITEM,
      order: 60,
    });
    // TODO: should fix id when all tabs in general setting will be removed.
    menu.addAdminMenuItem({
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'SYSTEM_SETTINGS_SETTINGS'),
      icon: 'pi pi-wrench',
      id: ADMIN_GENERAL_SETTINGS_ROUTE_NAME,
      order: 61,
    });
    menu.addAdminMenuItem({
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'MIRRORS_GROUP_HEADER'),
      icon: 'pi pi-external-link',
      id: ADMIN_MIRRORS_MENU_ITEM,
      order: 70,
    });
    menu.addAdminMenuItem({
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'ADMIN_EXPORT_GROUP_HEADER'),
      icon: 'pi pi-download',
      id: ADMIN_EXPORTS_MENU_ITEM,
      order: 80,
    });

    // affiliate
    menu.addAffiliateMenuItem({
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'TRACKING_LINKS_GROUP_HEADER'),
      icon: 'pi pi-link',
      id: AFFILIATE_TRACKING_LINKS_MENU_ITEM,
      order: 20,
    });
    menu.addAffiliateMenuItem({
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'REPORTS_GROUP_HEADER'),
      icon: 'pi pi-book',
      id: AFFILIATE_REPORTS_MENU_ITEM,
      order: 30,
    });
    menu.addAffiliateMenuItem({
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'AFFILIATE_PARTNERSHIP_GROUP_HEADER'),
      icon: 'pi pi-briefcase',
      id: AFFILIATE_PARTNERSHIP_MENU_ITEM,
      order: 40,
    });
    menu.addAffiliateMenuItem({
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'AFFILIATE_EXPORT_GROUP_HEADER'),
      icon: 'pi pi-download',
      id: AFFILIATE_EXPORTS_MENU_ITEM,
      order: 50,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_SIDEBAR, getTranslationKeys);
  }
}
